import { Component, OnInit } from '@angular/core';
import { ColumnMode } from '@siemens/ngx-datatable';
import { ToastrService } from '@shared/services/toastr.service';
import { UserRole } from '@shared/services/admin-user.service';
import { OrganizationTlsOptionsService, TlsOptions } from '@shared/services/organization-tls-options.service';
import { ADD_ROUTE } from 'app/app-routing.constants';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConfirmService } from '@shared/services/confirm.service';
import { extractCertInfo } from '@shared/utils/certificates';
import { HelpComponent } from '@shared/components/help/help.component';
import { NgStyle } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateFormatPipe } from '@shared/pipe/filter.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tls-options',
  templateUrl: './tls-options.component.html',
  styleUrls: ['./tls-options.component.scss'],
  imports: [HelpComponent, NgStyle, RouterLink, NgxPaginationModule, DateFormatPipe, TranslatePipe],
})
export class TlsOptionsComponent implements OnInit {
  ColumnMode = ColumnMode;

  tlsOptions: TlsOptions[] | null = null;
  nbTlsOptions: number = 0;
  page = 0;
  size = 10;
  total = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private organizationTlsOptionsService: OrganizationTlsOptionsService,
    private toastr: ToastrService,
    private confirmService: ConfirmService,
  ) {}

  ngOnInit() {
    this.loadTlsOptions();
  }

  addTlsOptions() {
    this.router.navigate(['tls-options', ADD_ROUTE], { relativeTo: this.route });
  }

  async deleteTlsOptions(tlsOptions: TlsOptions) {
    this.confirmService.confirm(
      {
        html: "Supprimer l'option TLS ?",
      },
      () =>
        this.organizationTlsOptionsService.removeTlsOptions(tlsOptions.uid).subscribe(() => {
          this.loadTlsOptions();
          this.toastr.success();
        }),
    );
  }

  changePage(e: number) {
    this.page = e - 1;
    this.loadTlsOptions();
  }

  loadTlsOptions() {
    this.organizationTlsOptionsService.getTlsOptions({ number: this.page, size: this.size }).subscribe((res) => {
      this.tlsOptions = res.content;
      this.nbTlsOptions = res.totalElements;
    });
  }

  protected readonly OWNER: UserRole = 'OWNER';
  protected readonly extractCertInfo = extractCertInfo;
}
